import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private  httpClient: HttpClient) {
  }

  getCountries() {
    return this.httpClient.get('/systemconfig/country/');
  }
///////////////////////////old//////////////////////////
  getCountry(id) {
    return this.httpClient.get(`/systemconfig/country/${id}/`);
  }
getCountrys(id){
  return this.httpClient.get('/systemconfig/countries/',{params : {id:id}})
}
  postCountry(country) {
    return this.httpClient.post('/systemconfig/country/', country);
  }


  ///////////////////// old/////////////////
  updateCountry(id, country) {
    return this.httpClient.patch(`/systemconfig/country/${id}/`, country);
  }

  updateCountrys(country){
    return this.httpClient.post('/systemconfig/countries/',country)
  }
}
